import * as React from 'react';

import type { ScaledValueProps } from '../scaled-value';
import { ScaledValue } from '../scaled-value';

export const NUMBER_SIZE_LABELS = [
  'ui:numberSize.o',
  'ui:numberSize.k',
  'ui:numberSize.m',
  'ui:numberSize.g',
  'ui:numberSize.t',
  'ui:numberSize.p',
];

type ScaledNumberProps = {
  number: number;
  base?: number;
} & Omit<ScaledValueProps, 'value' | 'base'>;

export const ScaledNumber: React.FC<ScaledNumberProps> = ({
  number,
  base = 1000,
  ...rest
}) => (
  <ScaledValue
    value={number}
    base={base}
    sizeLabels={NUMBER_SIZE_LABELS}
    {...rest}
  />
);
